import React, { useState, useEffect, useCallback, useContext } from "react";
import { BrowserRouter } from "react-router-dom";
import Provider, { Context } from "./components/Provider"; // Import Context
//import JobSearch from "./components/JobSearch";
import JobSearch from "./components/JobSearch-WithURLBuilder";
import JobResults from "./components/JobResults";
import JobDetails from "./components/JobDetails";
import LeftLinks from "./components/LeftLinks.js";
import LoadingBlock from "./components/LoadingBlock"; // Import LoadingBlock

const App = () => {
  const [width, setWidth] = useState(window.innerWidth),
    breakpoint = 768;

  useEffect(() => {
    const resizeWindowCheck = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", resizeWindowCheck);

    return () => {
      window.removeEventListener("resize", resizeWindowCheck);
    };
  }, []);
  
  const updateShowFilter = useCallback((e) => {
    if (e) e.preventDefault();
    document.body.classList.toggle("job-filter-active");
  }, []);

  return (
    <BrowserRouter>
      <Provider>
        <JobSearch />
        {/* Access the loading state from the context */}
        <Context.Consumer>
          {({ loading }) => (
            <section id="job_results" className="section-search-results">
              <div className="container wrap">
                <div className="row flex-container">
                  {/* Conditional rendering based on the loading state */}
                  {loading ? (
                    <div className="jobs-loading">
                        <LoadingBlock />
                        </div>
                  ) : (
                    <>
                      {/* Only render LeftLinks and other content when not loading */}
                      <LeftLinks updateShowFilter={updateShowFilter} />
                      <JobResults />
                      {width >= breakpoint && <JobDetails />}
                    </>
                  )}
                </div>
              </div>
            </section>
          )}
        </Context.Consumer>
      </Provider>
    </BrowserRouter>
  );
};

export default App;